import Howler from 'howler'; // eslint-disable-line no-unused-vars
import { ClientEngine, KeyboardControls } from 'lance-gg';
import SpaaaceRenderer from '../client/SpaaaceRenderer';
import MobileControls from './MobileControls';
import Ship from '../common/Ship';
import Utils from '../common/Utils';

export default class SpaaaceClientEngine extends ClientEngine {

    constructor(gameEngine, options) {
        super(gameEngine, options, SpaaaceRenderer);
    }

    start() {
        super.start();

        // handle gui for game condition
        this.gameEngine.on('objectDestroyed', (obj) => {
            if (obj instanceof Ship && this.gameEngine.isOwnedByPlayer(obj)) {
                document.body.classList.add('lostGame');
                document.body.classList.remove('gameActive');
                document.querySelector('#tryAgain').disabled = false;
                const nameInputEl = document.querySelector('#playerName');
                if (nameInputEl) {
                    nameInputEl.style.display = 'block';
                    nameInputEl.classList.remove('hidden');
                }
            }
        });

        this.gameEngine.once('renderer.ready', () => {
            // Pre-fill playerName input with saved name from localStorage or random pilot name
            const nameInput = document.querySelector('#playerName');
            if (nameInput) {
                try {
                    const savedName = localStorage.getItem('spaaace_player_name');
                    if (savedName && savedName.trim()) {
                        nameInput.value = savedName.trim();
                    } else if (!nameInput.value.trim()) {
                        const pilotPrefixes = ['Maverick', 'Phoenix', 'Viper', 'StarFox', 'Apollo', 'Falcon', 'Orion', 'Nova', 'Astra', 'Zephyr', 'Cosmo', 'Shadow', 'Spectre', 'Raptor', 'Blaze', 'Starlight'];
                        const randomName = pilotPrefixes[Math.floor(Math.random() * pilotPrefixes.length)] + '-' + Math.floor(100 + Math.random() * 900);
                        nameInput.value = randomName;
                    }
                } catch (err) {
                    if (!nameInput.value.trim()) {
                        const pilotPrefixes = ['Maverick', 'Phoenix', 'Viper', 'StarFox', 'Apollo', 'Falcon', 'Orion', 'Nova', 'Astra', 'Zephyr', 'Cosmo', 'Shadow', 'Spectre', 'Raptor', 'Blaze', 'Starlight'];
                        nameInput.value = pilotPrefixes[Math.floor(Math.random() * pilotPrefixes.length)] + '-' + Math.floor(100 + Math.random() * 900);
                    }
                }
            }

            const getPlayerName = () => {
                const el = document.querySelector('#playerName');
                let name = (el && el.value.trim()) ? el.value.trim() : '';
                if (!name) {
                    const pilotPrefixes = ['Maverick', 'Phoenix', 'Viper', 'StarFox', 'Apollo', 'Falcon', 'Orion', 'Nova', 'Astra', 'Zephyr', 'Cosmo', 'Shadow', 'Spectre', 'Raptor', 'Blaze', 'Starlight'];
                    name = pilotPrefixes[Math.floor(Math.random() * pilotPrefixes.length)] + '-' + Math.floor(100 + Math.random() * 900);
                    if (el) el.value = name;
                }
                try {
                    localStorage.setItem('spaaace_player_name', name);
                } catch (e) {
                    console.warn('Could not save player name to localStorage', e);
                }
                return name;
            };

            // click event for "try again" button
            document.querySelector('#tryAgain').addEventListener('click', () => {
                if (Utils.isTouchDevice()){
                    this.renderer.enableFullScreen();
                }
                const playerName = getPlayerName();
                const nameInputEl = document.querySelector('#playerName');
                if (nameInputEl) {
                    nameInputEl.style.display = 'none';
                    nameInputEl.classList.add('hidden');
                }
                this.socket.emit('requestRestart', { name: playerName });
            });

            document.querySelector('#joinGame').addEventListener('click', (clickEvent) => {
                if (Utils.isTouchDevice()){
                    this.renderer.enableFullScreen();
                }
                clickEvent.currentTarget.disabled = true;
                clickEvent.currentTarget.style.opacity = '0';
                clickEvent.currentTarget.style.pointerEvents = 'none';
                const playerName = getPlayerName();
                const nameInputEl = document.querySelector('#playerName');
                if (nameInputEl) {
                    nameInputEl.style.display = 'none';
                    nameInputEl.classList.add('hidden');
                }
                this.socket.emit('requestRestart', { name: playerName });
            });

            document.querySelector('#reconnect').addEventListener('click', () => {
                window.location.reload();
            });

            //  Game input
            if (Utils.isTouchDevice()){
                this.controls = new MobileControls(this);
                this.controls.on('fire', () => {
                    this.sendInput('space');
                });
            } else {
                this.controls = new KeyboardControls(this);
                this.controls.bindKey('left', 'left', { repeat: true });
                this.controls.bindKey('right', 'right', { repeat: true });
                this.controls.bindKey('up', 'up', { repeat: true } );
                this.controls.bindKey('space', 'space');
            }

        });

        // allow a custom path for sounds
        let assetPathPrefix = this.options.assetPathPrefix ? this.options.assetPathPrefix : '';

        // handle sounds
        this.sounds = {
            missileHit: new Howl({ src: [assetPathPrefix + 'assets/audio/193429__unfa__projectile-hit.mp3'] }),
            fireMissile: new Howl({ src: [assetPathPrefix + 'assets/audio/248293__chocobaggy__weird-laser-gun.mp3'] })
        };

        this.gameEngine.on('fireMissile', () => { this.sounds.fireMissile.play(); });
        this.gameEngine.on('missileHit', () => {
            // don't play explosion sound if the player is not in game
            if (this.renderer.playerShip) {
                this.sounds.missileHit.play();
            }
        });

        this.networkMonitor.on('RTTUpdate', (e) => {
            this.renderer.updateHUD(e);
        });
    }

    // extend ClientEngine connect to add own events
    connect() {
        return super.connect().then(() => {
            this.socket.on('scoreUpdate', (e) => {
                this.renderer.updateScore(e);
            });

            this.socket.on('disconnect', (e) => {
                console.log('disconnected');
                document.body.classList.add('disconnected');
                document.body.classList.remove('gameActive');
                document.querySelector('#reconnect').disabled = false;
            });

            if ('autostart' in Utils.getUrlVars()) {
                this.socket.emit('requestRestart');
            }
        });
    }

}
